import AbilityPointsRadarChart from '../../primary_admin/components/AbilityPointsRadarChart';

export default function AbilityPointsLeft() {
    return (
        <div className='w-full h-full flex bg-white'>
            <div className='flex-1 w-full flex flex-col bg-[white] rounded-[10px] p-[16px] font-bold justify-start items-center max-w-[400px]'>
                <div className='w-full pb-[4px]'>成績能力點</div>
                <AbilityPointsRadarChart data={[
                    {count:30,total:30,label:'1.1'},
                    {count:20,total:40,label:'1.2'},
                    {count:30,total:50,label:'2.1'},
                    {count:40,total:60,label:'2.2'},
                    {count:20,total:70,label:'2.3'},
                    {count:40,total:60,label:'2.4'},
                    {count:10,total:60,label:'3.1'},
                    {count:10,total:60,label:'3.2'},
                    {count:10,total:50,label:'3.3'},
                    {count:10,total:40,label:'4.1'},
                    {count:10,total:40,label:'4.2'}
                ]}/>
                <div className='w-full flex flex-col items-center justify-center gap-[8px] font-bold'>
                    1.1 獲取並提取文本內信息<br/>
                    1.2 跨來源搜索、導航與篩選<br/> 
                    2.1 建構文本字面意義<br/> 
                    2.2 生成推斷<br/> 
                    2.3 整合文本內信息<br/> 
                    2.4 整合跨文本信息<br/>
                    3.1 評估質量與真實性<br/>
                    3.2 反思內容與形式<br/> 
                    3.3 發現並處理衝突<br/> 
                    4.1 將理解遷移至新情境<br/> 
                    4.2 創造並傳達新意義<br/> 
                </div>
            </div>
        </div>
    );
}